<div class="change-region--head">
  <h1>
    Change region
  </h1>
  <svg-icon class="clear" src="/assets/icons/cross-thing.svg" (click)="closeDialog()"></svg-icon>
</div>
<div class="change-region--description">
    You are currently managing your applications in <b>{{urlHosted}}</b>.<br/>
    Choose a link below to leave this site and manage your REST API applications in a different region
</div>
<ul class="change-region--links">
  <li class="change-region--link" *ngIf="showLinkUrlHosted(prefixUrlHosted[2].key)"><a href="{{prefixApiPortalEnum.usa}}" (click)="closeDialog()">{{prefixUrlHosted[2].value}}</a></li>
  <li class="change-region--link" *ngIf="showLinkUrlHosted(prefixUrlHosted[1].key)"><a href="{{prefixApiPortalEnum.europe}}" (click)="closeDialog()">{{prefixUrlHosted[1].value}}</a></li>
  <li class="change-region--link" *ngIf="showLinkUrlHosted(prefixUrlHosted[0].key)"><a href="{{prefixApiPortalEnum.australia}}" (click)="closeDialog()">{{prefixUrlHosted[0].value}}</a></li>
</ul>
